export { default } from './GameDice'
